module.exports = __webpack_public_path__ + "assets/images/board.svg?bad23c1cb0d16f506bc5848c9f9582b3";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/board.svg
// module id = 626
// module chunks = 0